/**
 * Where the overheads come from. One anonymous endpoint serves both the table and the document it
 * generates from the same rows (HAT-1231), and both the portal's «אישורים ומסמכים» screen and the
 * public regulations page read it - so the rates are stated in exactly one place.
 */
export const OVERHEAD_FEES_URL = 'overhead-fees';

/** The document is served inline and needs no token, so «צפייה» can be a plain link. */
export const OVERHEAD_DOCUMENT_URL = `${OVERHEAD_FEES_URL}/document`;

export const overheadDocumentHref = `${import.meta.env.VITE_APP_API_URL}/api/${OVERHEAD_DOCUMENT_URL}`;

/**
 * HAT-1493: «טבלת תקורות» in the transactions board's export menu, a window with the same table.
 * The office asked for it there; Druk approved it on the export only (28.10.2026). Seeded NotReleased.
 */
export const OVERHEADS_TABLE_FEATURE_KEY = 'overheads-table';
